import React, { useEffect, useState } from "react";
import { Bag } from "react-bootstrap-icons";

const SplashScreen = ({ onFinish }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const appearTimer = setTimeout(() => {
      setIsVisible(true);
    }, 100); 

    const finishTimer = setTimeout(() => {
      setIsVisible(false); // fade out before unmount
      setTimeout(onFinish, 500); // wait for fade-out before calling onFinish
    }, 3000);

    return () => {
      clearTimeout(appearTimer);
      clearTimeout(finishTimer);
    };
  }, [onFinish]);

  return (
    <div className="fixed inset-0 z-[1000] bg-brand-orange flex flex-col items-center justify-center overflow-hidden">
      <div
        className={`flex flex-col items-center transition-all duration-700 ease-out transform ${
          isVisible
            ? "opacity-100 translate-y-0 scale-100"
            : "opacity-0 translate-y-8 scale-90"
        }`}
      >
        <div className="w-24 h-24 bg-white rounded-[32px] shadow-[0_20px_50px_rgba(0,0,0,0.2)] flex items-center justify-center mb-6">
          <Bag size={24} />
        </div>

        <h1 className="text-white text-3xl font-black tracking-tighter uppercase">
          DukaanSetu
        </h1>

        <div className="mt-4 w-12 h-1 bg-white/20 rounded-full overflow-hidden">
          <div className="w-full h-full bg-white animate-pulse" />
        </div>
      </div>

      <div
        className={`absolute bottom-12 transition-opacity duration-1000 delay-500 ${
          isVisible ? "opacity-50" : "opacity-0"
        }`}
      >
        <p className="text-[10px] font-bold text-white uppercase tracking-[0.4em]">
          DukaanSetu Security System
        </p>
      </div>
    </div>
  );
};

export default SplashScreen;